import "./App.css";

const starterModules = [
  "CDK package wired into the pipeline",
  "Lambda package scaffolded for service entrypoints",
  "Galaxy DAG package scaffolded for orchestration",
  "React package scaffolded for the UI shell",
];

function App() {
  return (
    <main className="app-shell">
      <section className="hero">
        <p className="eyebrow">Sponsored Products</p>
        <h1>SPB Weblab Insight Tool</h1>
        <p className="summary">
          This starter UI mirrors the basic FINN package structure so we can plug in
          auth, data fetching, and AppSync-backed screens incrementally.
        </p>
      </section>

      <section className="status-card">
        <h2>Starter Setup</h2>
        <ul>
          {starterModules.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>
    </main>
  );
}

export default App;
